export default {
  ziweiMaj: '자미',
  tianjiMaj: '천기',
  taiyangMaj: '태양',
  wuquMaj: '무곡',
  tiantongMaj: '천동',
  lianzhenMaj: '염정',
  tianfuMaj: '천부',
  taiyinMaj: '태음',
  tanlangMaj: '탐랑',
  jumenMaj: '거문',
  tianxiangMaj: '천상',
  tianliangMaj: '천량',
  qishaMaj: '칠살',
  pojunMaj: '파군',
  zuofuMin: '좌보',
  youbiMin: '우필',
  wenchangMin: '문창',
  wenquMin: '문곡',
  lucunMin: '록존',
  tianmaMin: '천마',
  qingyangMin: '경양',
  tuoluoMin: '타라',
  huoxingMin: '화성',
  lingxingMin: '령성',
  tiankuiMin: '천괴',
  tianyueMin: '천월',
  dikongMin: '지공',
  dijieMin: '지겁',
  tiankong: '천공',
  tianxing: '천형',
  tianyao: '천요',
  jieshen: '해신',
  yinsha: '음살',
  tianxi: '천희',
  tianguan: '천관',
  tianfu: '천복',
  tianku: '천곡',
  tianxu: '천허',
  longchi: '용지',
  fengge: '봉각',
  hongluan: '홍란',
  guchen: '고진',
  guasu: '과숙',
  feilian: '비렴',
  posui: '파쇄',
  taifu: '태보',
  fenggao: '봉고',
  tianwu: '천무',
  tianyue: '천월',
  santai: '삼태',
  bazuo: '팔좌',
  engguang: '은광',
  tiangui: '천귀',
  tiancai: '천재',
  tianshou: '천수',
  jiekong: '절중',
  xunzhong: '순중',
  xunkong: '순공',
  kongwang: '공망',
  jielu: '절로',
  yuede: '월덕',
  tianshang: '천상',
  tianshi: '천사',
  tianchu: '천주',
  changsheng: '장생',
  muyu: '목욕',
  guandai: '관대',
  linguan: '임관',
  diwang: '제왕',
  shuai: '쇠',
  bing: '병',
  si: '사',
  mu: '묘',
  jue: '절',
  tai: '태',
  yang: '양',
  boshi: '박사',
  lishi: '역사',
  qinglong: '청룡',
  xiaohao: '소모',
  jiangjun: '장군',
  zhoushu: '주서',
  faylian: '비렴',
  xishen: '희신',
  bingfu: '병부',
  dahao: '대모',
  fubing: '복병',
  guanfu: '관부',
  suijian: '태세',
  huiqi: '회기',
  sangmen: '상문',
  guansuo: '관색',
  gwanfu: '관부',
  longde: '용덕',
  baihu: '백호',
  tiande: '복덕',
  diaoke: '조객',
  jiangxing: '장성',
  panan: '반안',
  suiyi: '세역',
  xiishen: '식신',
  huagai: '화개',
  jiesha: '겁살',
  zhaisha: '재살',
  tiansha: '천살',
  zhibei: '지배',
  xianchi: '함지',
  yuesha: '월살',
  wangshen: '망신',
  yunkui: '천괴(십년)',
  yunyue: '천월(십년)',
  yunchang: '문창(십년)',
  yunqu: '문곡(십년)',
  yunluan: '홍란(십년)',
  yunxi: '천희(십년)',
  yunlu: '록존(십년)',
  yunyang: '경양(십년)',
  yuntuo: '타라(십년)',
  yunma: '천마(십년)',
  liukui: '천괴(년)',
  liuyue: '천월(년)',
  liuchang: '문창(년)',
  liuqu: '문곡(년)',
  liuluan: '홍란(년)',
  liuxi: '천희(년)',
  liulu: '록존(년)',
  liuyang: '경양(년)',
  liutuo: '타라(년)',
  liuma: '천마(년)',
  nianjie: '해신(년)',
  yuekui: '천괴(월)',
  yueyue: '천월(월)',
  yuechang: '문창(월)',
  yuequ: '문곡(월)',
  yueluan: '홍란(월)',
  yuexi: '천희(월)',
  yuelu: '록존(월)',
  yueyang: '경양(월)',
  yuetuo: '타라(월)',
  yuema: '천마(월)',
  rikui: '천괴(일)',
  riyue: '천월(일)',
  richang: '문창(일)',
  riqu: '문곡(일)',
  riluan: '홍란(일)',
  rixi: '천희(일)',
  rilu: '록존(일)',
  riyang: '경양(일)',
  rituo: '타라(일)',
  rima: '천마(일)',
  shikui: '천괴(시)',
  shiyue: '천월(시)',
  shichang: '문창(시)',
  shiqu: '문곡(시)',
  shiluan: '홍란(시)',
  shixi: '천희(시)',
  shilu: '록존(시)',
  shiyang: '경양(시)',
  shituo: '타라(시)',
  shima: '천마(시)',
} as const;
